import {defineNuxtPlugin} from 'nuxt/app';
import {useFeatureFlagsStore} from '../stores/feature-flags.store';

export default defineNuxtPlugin({
    name: 'nuxt-admin-components-load-ff',
    dependsOn: ['backend-api-cookies', 'fetch-auth'],
    async setup() {
        const {loadFeatureFlags} = useFeatureFlagsStore();
        await loadFeatureFlags();
    },
});
